/* html読み込み後の処理
-------------------------------------------------- */
document.addEventListener('DOMContentLoaded', function(){
  // ページの表示
  var html = document.querySelectorAll("html, body");
  if(html.length > 0){
    for (let i = 0; i < html.length; i++) {
      html[i].style.opacity = "1";
    }
  }
  setHeaderH();
});

/* ヘッダー高さ取得
-------------------------------------------------- */
window.addEventListener("resize", setHeaderH);
function setHeaderH(){
  var headerH = document.getElementById("header").clientHeight;
  var top = document.getElementById("page-top");
  var content = document.getElementById("page-under");
  if(content){
    content.style.marginTop = headerH + "px";
  } else {
    top.style.marginTop = headerH + "px";
  }
}

/* スムーススクロール
-------------------------------------------------- */
const smoothScrollTrigger = document.querySelectorAll('a[href^="#"]');
for (let i = 0; i < smoothScrollTrigger.length; i++) {
  smoothScrollTrigger[i].addEventListener("click", (e) => {
    e.preventDefault();
    let href = smoothScrollTrigger[i].getAttribute("href");
    let targetElement = document.getElementById(href.replace("#", ""));
    const rect = targetElement.getBoundingClientRect().top;
    const offset = window.pageYOffset;
    const gap = document.getElementById("header").clientHeight;
    const target = rect + offset - gap;
    window.scrollTo({
      top: target,
      behavior: "smooth"
    });
  });
}
window.onload = function () {
  var urlHash = location.hash;
  if(urlHash){
    let targetElement = document.getElementById(urlHash.replace("#", ""));
    const rect = targetElement.getBoundingClientRect().top;
    const offset = window.pageYOffset;
    const gap = document.getElementById("header").clientHeight + 10;
    const target = rect + offset - gap;
    window.scrollTo({
      top: target,
      behavior: "smooth"
    });
  }
};

/* メニュー開閉
-------------------------------------------------- */
// Triggers demonstration on button click
document.getElementById("menu").onclick = function(){
  var elem = document.getElementById("header-menu");
  elem.classList.toggle('active');
  var topBar = document.getElementById("top-bar");
  topBar.classList.toggle('active');
};
const menuLink = document.querySelectorAll('.header_menu_item a');
for (let i = 0; i < menuLink.length; i++){
  menuLink[i].addEventListener('click', function(e){
    var elem = document.getElementById("header-menu");
    elem.classList.remove('active');
    document.getElementById("menu").checked = false;
    var topBar = document.getElementById("top-bar");
    topBar.classList.remove('active');
  });
}

/* 個数アップダウン
-------------------------------------------------- */
$(".btn-quantity").click(function (e) {

  e.preventDefault();

  fieldName = $(this).attr("data-field");
  type = $(this).attr("data-type");
  var input = $(".input-product-single__quantity");
  var currentVal = parseInt(input.val());

  if (!isNaN(currentVal)) {
    if (type == "minus") {
      if (currentVal > 1) {
        input.val(currentVal - 1).change();
      }
    } else if (type == "plus") {
      input.val(currentVal + 1).change();
    }
  } else {
    input.val(0);
  }
});